import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  prices: {
    tierName: '',
    price: '',
    minUsdPrice: '',
    fsc: '',
    eph: '',
    specialNoweight: true,
  },
};

export const createPrices = createSlice({
  name: 'createPrices',
  initialState,
  reducers: {
    updatePricesInfo: (state, action) => {
      state.prices = action.payload;
    },
    updatePricesInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.prices[field] = value;
    },
    clearPricesInfo: (state) => {
      state.prices = { ...initialState.prices };
    },
  },
});

export const { updatePricesInfo, updatePricesInfoField, clearPricesInfo } = createPrices.actions;

export const pricesDetailSelector = (state) => state.createPrices.prices;

export const createPricesReducer = createPrices.reducer;
export const createPricesReducerName = 'createPrices';

export default createPrices.reducer;
